import styled from '@emotion/styled'
import { Accordion, type AccordionProps } from '@mui/material'
import { theme as newTheme } from 'styles/theme/hav-theme'

interface AccordionStyledProps extends AccordionProps {
  height: number
  width: string
}

export const AccordionStyled = styled(Accordion)<AccordionStyledProps>`
  height: ${({ height }) => height};
  width: ${({ width }) => width};

  #AccordionTitle {
    color: ${newTheme.colors.neutral.black};
    font-size: ${newTheme.typography.sizes.sm};
    font-family: ${newTheme.typography.family.primary};
    font-weight: ${newTheme.typography.weight.lg};
  }

  #AccordionSubtitle {
    font-size: ${newTheme.typography.sizes.xs};
    font-family: ${newTheme.typography.family.primary};
    font-weight: ${newTheme.typography.weight.lg};

    color: ${newTheme.colors.neutral.medium};
    white-space: nowrap;

    @media (max-width: 767px) {
      font-size: ${newTheme.typography.sizes['2xs']};
    }
  }

  #AccordionSubtitleDescription {
    font-family: ${newTheme.typography.family.primary};
    font-size: ${newTheme.typography.sizes.sm};

    color: ${newTheme.colors.neutral.medium};
    margin-top: ${newTheme.spacing.xs};
    white-space: nowrap;

    @media (max-width: 767px) {
      font-size: ${newTheme.typography.sizes.xs};
    }
  }

  border-radius: ${newTheme.shapes.borderRadius.md};
  box-shadow: ${newTheme.effects.boxShadow['rule-01']};
  padding: ${newTheme.spacing.md};
  margin: 0 !important;

  :before {
    background-color: transparent;
  }

  .MuiAccordionSummary-root {
    padding: 0;
    min-height: auto !important;
  }
  :before {
    background-color: transparent;
  }

  .MuiAccordionSummary-contentGutters {
    margin: 0;
  }

  .Mui-expanded .MuiAccordionSummary-contentGutters {
    margin: 0;
    height: auto;
  }
  .MuiAccordionDetails-root {
    padding: 0;
    margin-top: ${newTheme.spacing.md};
    @media (max-width: 767px) {
      padding-top: ${newTheme.spacing.md};
      margin-top: ${newTheme.spacing.md};
    }
  }

  .MuiAccordionSummary-root .MuiSvgIcon-root {
    font-size: ${newTheme.icon.size.big};
    fill: ${newTheme.colors.primary.main};
    @media (max-width: 767px) {
      font-size: ${newTheme.icon.size.x.medium};
    }
  }
  border-radius: ${newTheme.shapes.borderRadius.md} !important;
`
